import { render } from "./agrement-detail.vue?vue&type=template&id=6c9f5ef0&scoped=true"
import script from "./agrement-detail.vue?vue&type=script&lang=js"
export * from "./agrement-detail.vue?vue&type=script&lang=js"

import "./agrement-detail.vue?vue&type=style&index=0&id=6c9f5ef0&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9f5ef0"]])

export default __exports__